/**
 * VaultSummary — Reuse / Refresh / Generate totals from Sprint 3.
 *
 * We deliberately re-render the Sprint 3 component so the copy stays
 * identical whether the owner looks at it during strategy review or
 * from inside the Campaign Room.
 */
import { ContentStrategySection } from "@/features/marketing-strategy/ui/sections/ContentStrategySection";
import type { ContentStrategyBlock } from "@/features/marketing-strategy/types";

export function VaultSummary({
  content,
}: {
  content: ContentStrategyBlock;
}): JSX.Element {
  return (
    <section data-testid="room-vault-summary">
      <ContentStrategySection content={content} />
    </section>
  );
}
